module.exports = __webpack_public_path__ + "img/bg-kleyn.83aecac3.jpg";